import { get, post } from "../../helpers/api_helper"

export const listWorkforce = ({ page = 1, params = "" } = {}) =>
  get(`workforce-employee/list/${page}?${params}`)

export const fetchWorkforceEmployee = id => get(`workforce-employee/fetch/${id}`)

export const postWorkforce = data =>
  !data?.id
    ? post(`workforce-employee/create`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    : post(`workforce-employee/edit/${data.id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })

export const workforceStatus = id => get(`workforce-employee/updatestatus/${id}`)

export const getHrDashboard = () => get(`workforce-employee/dashboard`)

export const getExpiryPivot = type => get(`workforce-employee/expiry-pivot?type=${type}`)

export const getExpiryList = qs => get(`workforce-employee/expiry-list?${qs}`)
